import React, { memo } from "react";
import InstantWinFormComponent from "./instantWinForm.component";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const TYPES = ["new", "edit", "readonly"];

function InstantWinFormContainer({
  type,
  handleResult,
  initialValues,
  handleDelete,
  handleClose,
}) {
  const lang = useSelector((state) => state.constant.languages);

  return (
    <InstantWinFormComponent
      type={type}
      handleSubmit={handleResult}
      handleDelete={handleDelete}
      initialValues={initialValues}
      lang={lang}
      handleClose={handleClose}
    />
  );
}

InstantWinFormContainer.defaultProps = {
  type: TYPES[0],
};

InstantWinFormContainer.propTypes = {
  type: PropTypes.oneOf(TYPES).isRequired,
  handleResult: PropTypes.func,
  handleDelete: PropTypes.func,
};

export { TYPES };

export default memo(InstantWinFormContainer, (oldProps, newProps) => {
  return (
    oldProps.initialValues === newProps.initialValues ||
    oldProps.initialValues?.id === newProps.initialValues?.id
  );
});
